import { render, staticRenderFns } from "./TabsEvents.vue?vue&type=template&id=141d19c2&"
import script from "./TabsEvents.vue?vue&type=script&lang=js&"
export * from "./TabsEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports